/* eslint-disable react/no-danger */
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MKButton from "components/MKButton";
import { Link } from "react-router-dom";

function MapZones() {
  return (
    <>
      <MKBox component="section" style={{ marginTop: "150px", marginBottom: "150px" }}>
        <Container>
          <Grid container alignItems="center">
            <Grid item xs={12} lg={5}>
              <MKTypography variant="h2" color="inherit" style={{ fontSize: "60px" }}>
                Centro Histórico de San Miguel
              </MKTypography>
              <MKTypography variant="h2" color="info" mb={2}>
                <MKTypography variant="h1" color="#000" />
              </MKTypography>
              <MKTypography
                variant="body2"
                color="inherit"
                opacity={0.8}
                style={{ fontSize: "18px" }}
              >
                Revitalización del Centro Histórico de San Miguel a través de Herramientas
                Tecnológicas.
              </MKTypography>
              <br />
              <br />
              <Link to="/search">
                <MKButton style={{ marginLeft: "0px", backgroundColor: "#344767", color: "#fff" }}>
                  Inmuebles
                </MKButton>
              </Link>
              &nbsp; &nbsp;
              <Link to="/userguide">
                <MKButton
                  style={{ marginLeft: "0px", backgroundColor: "#F0F2F5", color: "#344767" }}
                >
                  Guía de Uso
                </MKButton>
              </Link>
            </Grid>
            <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
              <Stack>
                <MKBox display="flex" alignItems="right">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        "<iframe width='800' height='350' frameborder='0' src='https://widgets.scribblemaps.com/sm/?d&z&ol&l&gc&af&mc&lat=13.482547656&lng=-88.177685688&vz=16&type=custom_style&ti&s&width=550&height=400&id=dD0KHqq9D2' style='border:0; max-width: 100%;' allowfullscreen allow='geolocation' loading='lazy' />",
                    }}
                  />
                </MKBox>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
}

export default MapZones;
